import MobileLogin from '@/views/mobile/userPages/login.vue' //登陆
import MobileRegister from '@/views/mobile/userPages/register.vue' //注册
import MobileForget from '@/views/mobile/userPages/forget.vue' //服务协议  
import MobileHome from '@/views/mobile/tabbarPages/home/index.vue' //主页面 首页
import MobileMine from '@/views/mobile/tabbarPages/mine/index.vue' //主页面 资产 
import MobileQuotes from '@/views/mobile/tabbarPages/quotes/index.vue' //主页面 行情页面
import MobileService from '@/views/mobile/tabbarPages/service/index.vue' //主页面 理财
import MobileTrade from '@/views/mobile/tabbarPages/trade/index.vue'//主页面 交易
const main = [
    {
        path: "login",
        name: "login",
        component: MobileLogin,
        meta: {
            title: "",
        },
    },
    {
        path: "register",
        name: "register",
        component: MobileRegister,
        meta: {
            title: "",
        },
    },
    {
        path: "forget",
        name: "forget",
        component: MobileForget,
        meta: {
            title: "",
        },
    },
    {
        path: "home",
        name: "home",
        component: MobileHome,
        meta: {
            title: "",
        },
    },
    {
        path: "mine",
        name: "mine",
        component: MobileMine,
        meta: {
            title: "",
        },
    },
    {
        path: "quotes",
        name: "quotes",
        component: MobileQuotes,
        meta: {
            title: "",
        },
    },
    {
        path: "service",
        name: "service",
        component: MobileService,
        meta: {
            title: "",
        },
    },
    {
        path: "trade",
        name: "trade",
        component: MobileTrade,
        meta: {
            title: "",
        },
    },
    {
        path: "topUp",
        name: "topUp",
        component: () => import("@/views/mobile/tabbarPages/mine/topUp"), //充值页面
        meta: {
            title: "",
        },
    },
    {
        path: "extract",
        name: "extract",
        component: () => import("@/views/mobile/tabbarPages/mine/extract"),//提币页面
        meta: {
            title: "",
        },
    },
    {
        path: "exchange",
        name: "exchange",
        component: () => import("@/views/mobile/tabbarPages/mine/exchange"), // 闪兑 月面
        meta: {
            title: "",
        },
    },
    // {
    //     path: "convert",
    //     name: "convert",
    //     component: () => import("@/views/mobile/tabbarPages/mine/convert"), // 划转  //暂时不用 我要修改成组件
    //     meta: {
    //         title: "",
    //     },
    // },
    {
        path: "invitation",
        name: "invitation",
        component: () => import("@/views/mobile/tabbarPages/home/invitation"), //分享好友  页面
        meta: {
            title: "",
        },
    },
    {
        path: "quick",
        name: "quick",
        component: () => import("@/views/mobile/tabbarPages/home/quick"), //快捷买币 页面
        meta: {
            title: "",
        },
    },
    {
        path: "history",
        name: "history",
        component: () => import("@/views/mobile/tabbarPages/home/history"), //快捷买币-下面的-历史账单页面
        meta: {
            title: "",
        },
    },
    {
        path: "aiTrade",
        name: "aiTrade",
        component: () => import("@/views/mobile/tabbarPages/home/aiTrade"), // AI策略交易页面
        meta: {
            title: "",
        },
    },
    {
        path: "contract",
        name: "contract",
        component: () => import("@/views/mobile/tabbarPages/trade/contract"), // 合约
        meta: {
            title: "",
        },
    },
    {
        path: "spotGoods",
        name: "spotGoods",
        component: () => import("@/views/mobile/tabbarPages/trade/spotGoods"), // 现货
        meta: {
            title: "",
        },
    },
    {
        path: "details",
        name: "details",
        component: () => import("@/views/mobile/tabbarPages/home/details"), // 资讯详情
        meta: {
            title: "",
        },
    },
    {
        path: "grade",
        name: "grade",
        component: () => import("@/views/mobile/tabbarPages/service/grade"), // 等级规则
        meta: {
            title: "",
        },
    },
    {
        path: "aiOrder",
        name: "aiOrder",
        component: () => import("@/views/mobile/tabbarPages/home/aiOrder"), // ai订单
        meta: {
            title: "",
        },
    },
    {
        path: "order",
        name: "order",
        component: () => import("@/views/mobile/tabbarPages/service/order"), // 投资订单
        meta: {
            title: "",
        },
    },
    {
        path: "certification",
        name: "certification",
        component: () => import("@/views/mobile/tabbarPages/home/certification"), // 实名认证
        meta: {
            title: "",
        },
    },
    {
        path: "resetPwd",
        name: "resetPwd",
        component: () => import("@/views/mobile/tabbarPages/mine/resetPwd"), // 充值密码
        meta: {
            title: "",
        },
    },
    {
        path: "borrowMoney",
        name: "borrowMoney",
        component: () => import("@/views/mobile/tabbarPages/home/borrowMoney"), //借币
        meta: {
            title: "",
        },
    }



]

export default main